import React from 'react'
import styled from 'styled-components'
import { Modal } from 'reactstrap'

import { CloseIcon } from '../icons'
import { FONTS } from '../../constants'

export const SimpleModal = ({ isOpen, type, title, description, toggle, actions }) => {
  return (
    <Modal isOpen={ isOpen } toggle={ toggle }>
      <ModalHeader>
        <Header type={ type }>{ title }</Header>
        <CloseIcon onClick={ toggle } />
      </ModalHeader>
      <Body>
        <Text>{ description }</Text>
      </Body>
      <Footer>{ actions }</Footer>
    </Modal>
  )
}

const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 0 16px;
`

const Header = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${p => {
    if (p.type === 'success') return '#27AE60'
    else if (p.type === 'error') return '#D44B49'
    return '#333333'
  }};
`

const Body = styled.div`
  display: flex;
  padding: 24px 16px;
`

const Footer = styled.div`
  height: 42px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F9F9F9;
  padding: 0 16px;
`

const Text = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #333333;
`



// WEBPACK FOOTER //
// ./src/components/modal/simple-modal.js